import React from "react";
import {localField} from "../../../../_ae/helpers/UIHelper";
import {fetchAttributesForSelect, useAttributesForSelect} from "../../../../redux/attributes";
import {AEAutocompleteField} from "../../../../_metronic/_partials/controls/forms/AEField";
import {useDispatch} from "react-redux";

export const Field = ({...props}) => {
  const dispatch = useDispatch();
  const {data, isLoading, metadata} = useAttributesForSelect()

  const handleSearch = search => {
    dispatch(
      fetchAttributesForSelect({
        ...metadata,
        filters: {
          ...metadata.filters,
          search
        }
      })
    )
  }

  return (
    <AEAutocompleteField
      name="attribute"
      label={'ATTRIBUTE'}
      options={data}
      getOptionLabel={option=>option[localField()]}
      onOpen={()=>{
        handleSearch('')
      }}
      onInputChange={(event, search) => {
        handleSearch(search)
      }}
      loading={isLoading}
      {...props}
    />
  )
}